import { useTopic } from "pages/TopicViewer/hooks/use-topics";
import { useMicRecorder, useModus, VojomoLoader } from "@vojomo-core/shared";
import { ToolBar } from "../ToolBar";
import { OutputEditorProvider } from "pages/TopicViewer/hooks/use-output-editor";
import { OutputViewer } from "pages/TopicViewer/OutputViewer";
import { BlankDoc } from "pages/TopicViewer/BlankDoc";

export const TopicContent = () => {
  const { isLoadingOutput, output, hasWriteAccess, isStreaming } = useTopic();
  const { isBusy } = useMicRecorder();
  const { isWaitingForResponse } = useModus();

  if (isLoadingOutput) {
    return <VojomoLoader />;
  }

  if (!output) {
    return (
      <BlankDoc
        selectDisabled={
          isBusy || isWaitingForResponse || !hasWriteAccess || isStreaming
        }
      />
    );
  }

  return (
    <OutputEditorProvider>
      <div className="topic-content">
        <ToolBar />
        <OutputViewer />
      </div>
    </OutputEditorProvider>
  );
};
